import api from "@/api";
import DataResponse from "@/types/DataResponse";
import Row from "@/types/Mapping/Row";
import { AxiosResponse } from "axios";

export default async function getSectorRows(eventId: string, sectorId: string): Promise<Row[]> {
  const response: AxiosResponse<DataResponse<Row[]>> = await api.get(`/api/mapping/event/${eventId}/rows/${sectorId}`);
  return response.data.data;
}
